module.exports = __webpack_public_path__ + "media/landing_page/shoppers-shopper-1-e514c213.jpg";